
/*
 UXS OUTRO V23
 Ente blanco y más nítido en celular.
 Conserva la transición V22, fotos, X final y tipografía UXS.
 Archivo completo para Shopify > Assets > uxs-outro.js
*/
(() => {
  'use strict';

  const scriptURL = document.currentScript?.src || '';

  function boot() {
    if (!document.getElementById('uxs-experience')) return;
    if (window.UXSOutro?.version === 'v23') return;

    const TAU = Math.PI * 2;

    const C = {
      move: 31,
      appear: 32,
      links: 34.2,
      spawn: 37.35,
      fold: 40.75,
      song: 42,
      formed: 47.2,
      parents: 10,
      per: 130,
      N: 512,
      fps: 30
    };

    const END = {
      appear: 193.8,
      rapid: 193.8,
      photoEnd: 205.5,
      xBegin: 203,
      xLock: 209.8,
      title: 209.9,
      end: 212.365
    };

    const clamp = (x, a = 0, b = 1) =>
      Math.max(a, Math.min(b, x));

    const lerp = (a, b, p) =>
      a + (b - a) * p;

    const smooth = (a, b, t) => {
      const q = clamp((t - a) / (b - a));
      return q * q * (3 - 2 * q);
    };

    const hash = x => {
      const v = Math.sin(x * 127.1 + 91.3) * 43758.5453;
      return v - Math.floor(v);
    };

    // INTERFAZ

    document.querySelectorAll(
      '[id^="uxs-outro-v"]:not(script):not(style),' +
      '[class*="uxs-v"][class*="-test"]'
    ).forEach(el => el.remove());

    const st = document.createElement('style');
    st.id = 'uxs-outro-v23-css';

    st.textContent = `
      #uxs-outro-v23 {
        position: fixed;
        inset: 0;
        display: none;
        z-index: 9998;
        background: #050505;
        color: white;
        font-family: monospace;
        overflow: hidden;
      }
      #uxs-outro-v23.open {
        display: block;
      }
      #uxs-outro-v23 canvas {
        width: 100%;
        height: 100%;
        display: block;
      }
      #uxs-outro-v23 .sub {
        position: absolute;
        bottom: clamp(85px,14vh,160px);
        left: 50%;
        transform: translateX(-50%);
        width: min(88vw,660px);
        font: clamp(13px,2vw,19px)/1.7 monospace;
        letter-spacing: 1px;
        text-align: center;
        pointer-events: none;
      }
      #uxs-outro-v23 .state {
        position: absolute;
        top: 20px;
        left: 0;
        right: 0;
        text-align: center;
        letter-spacing: 2px;
        font: 10px monospace;
        color: #999;
      }
      #uxs-outro-v23 .ctrl {
        position: absolute;
        bottom: 18px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 8px;
        max-width: 95vw;
        flex-wrap: wrap;
        justify-content: center;
      }
      #uxs-outro-v23 button,
      .uxs-v23-test {
        color: white;
        background: #050505;
        border: 1px solid #777;
        border-radius: 25px;
        padding: 11px 14px;
        font: 11px monospace;
        cursor: pointer;
      }
      .uxs-v23-test {
        position: fixed;
        bottom: 18px;
        right: 18px;
        z-index: 9999;
      }
    `;

    document.head.append(st);

    const scene = document.createElement('section');
    scene.id = 'uxs-outro-v23';

    scene.innerHTML = `
      <canvas></canvas>
      <div class="state">UXS / VOICE001</div>
      <div class="sub"></div>
      <div class="ctrl">
        <button data-action="toggle">PAUSAR</button>
        <button data-action="jump">00:29</button>
        <button data-action="endjump">03:14</button>
        <button data-action="photos">FOTOS</button>
        <button data-action="testx">PROBAR X</button>
        <button data-action="exit">SALIR</button>
      </div>
      <audio preload="metadata"></audio>
    `;

    document.body.append(scene);

    const canvas = scene.querySelector('canvas');
    const g = canvas.getContext('2d', {alpha: false});
    const audio = scene.querySelector('audio');
    const sub = scene.querySelector('.sub');
    const status = scene.querySelector('.state');
    const toggle = scene.querySelector('[data-action="toggle"]');

    const kickDebug = document.createElement('div');

    kickDebug.style.cssText =
      'position:absolute;left:16px;bottom:18px;' +
      'color:#777;font:10px monospace;pointer-events:none';

    kickDebug.textContent = 'KICK --';
    scene.append(kickDebug);

    audio.src = window.UXSOutroAudioURL || '';

    let W = 1;
    let H = 1;
    let DPR = 1;
    let active = false;
    let raf = 0;
    let lastPaint = 0;
    let lastPhysics = 0;

    let ac = null;
    let an = null;
    let source = null;
    let td = null;
    let fd = null;

    // ANÁLISIS DE AUDIO

    const B = {
      level: 0,
      bass: 0,
      mid: 0,
      high: 0,
      impact: 0,
      cut: 0,
      shiver: 0,
      voice: 0,
      voiceHit: 0,
      thump: 0,
      xPulse: 0
    };

    let prevLevel = 0;
    let prevBass = 0;
    let average = 0;
    let slowBass = 0;
    let prevVoice = 0;
    let prevRawBass = 0;

    let kickSpectrum = null;
    let kickAverage = 0.025;
    let kickNoise = 0.004;
    let lastKickTime = -100;
    let bassEnergyPrev = 0;

    // Marcadores extraídos del outro completo.
    // Los snares son candidatos de la mezcla, no stems aislados.

    const KICK_DATA =
      'Fc8WBxY9FnIWpxbeFwIXFBc3F0oXgBeZF7cX7hgk' +
      'GDcYWxiSGKUYyBjoGP8ZNxlvGacZ2xoPGiYaRhp9' +
      'Gp8asxrpGyAbMhtWG40brRvEG/kcMRxEHGYcoBzY' +
      'HQ8dLx1EHXgdrx3mHhseLx5SHmYeiR6bHr8e9R8' +
      'JHy0fYx92H5of0CAJIEEgZCB4IJggrCDhIRghPC' +
      'FOIYQhqSG7Ic8h8SIEIiciXyKWIrAiyyLfIwIjO' +
      'CNyI6kjvSPgJAAkFSRJJIAkpCS3JOwlESUjJTclW' +
      'SVsJZAlxiXaJf0mNCZHJmsnDydJJ34nsyfpKCAo' +
      'VihpKIwowyj5KTApQylnKYcpnSoKKiAqQip7KrIq' +
      '5yscKzcrUiuJK/UsLCxiLIAsmizQLOctBi0qLT0t' +
      'ci2JLast4y4bLi8uTy5mLoUuoC67LvIvJy9eL5' +
      'Qv2DACMBwwOjBwMIYwujRHN643wzfmOB44VjiJOL' +
      '449TkZOSw5YTmGOZg5rDnOOeE6BTo8OlE6czqo' +
      'OuA7FTssO047hju+O/I8JzxePJQ8yj0APTc9bj2' +
      'kPbg92z37PhI+JT5JPmU+gD6UPrY+7z8mP1s/dT' +
      '+QP6w/xj/9QDNAakCgQORBDkEhQURBakGOQbFB5k' +
      'H9Qh9CWEKPQqlCxEL5Qy9DZkOcQ9JECURMRHdEiU' +
      'SuRORFLki6SPFJKUlhSZVJykoASjdKbUqjSrhK2k' +
      'rtSxBLR0taS35LtUvHS+tMIkxaTJJMykz+TTJNa' +
      'U2gTdZN6U4MTkNOVU55TrBO508cT1RPaE+JUe1SIQ==';

    const SNARE_DATA =
      'FowWpxbBFvcXExcuF2QXmxfSGAkZGxk2GVIZiBmj' +
      'Gb4Z9RoPGioaYBp8GpcazRsEGzsbXBtyG5EbyBw1' +
      'HGwcgxyeHLsc8R0LHScdXR14HZMdtB3JHeUd/x42' +
      'Hm0eox7FHtof7B/2IAcgJCA6IEUgWiB0IJAgxiDd' +
      'IPohFiExIUghXCGfIdYh/SIMIi0iQyJUIpki1SMA' +
      'IysjVCNeI28jjCOkI8Ij3SP4JC4kSSRTJJYktiT' +
      'QJQclPiV1JasmACZDJm0mmibDJtQnCyfNJ+QoAyg' +
      'iKDkoVShwKKco0ijeKRUpKSmtKgMqJioxKkEqXyp' +
      '0KpQqrirKKwArFys1K1crbCuDK5cr2SwQLDcsRix' +
      'nLH0sji0PLZgtqS3HLd4t/S4XLjMuaS6ELo4u0C' +
      '7wLwsvQi94L5gvry/FL9Av5jB9MPkxCTFFMdkyB' +
      'DIiMpEzZDOHM+80cTSxNW41ozXeNfQ2czacNsk27' +
      'Dc7N0k3cjegN7I3yTfkOAE4GzgqODc4UThtOIE4' +
      'ozi+ONk5BDkOOSs5RTlbOXw5sznROd856joKOiA' +
      '6NTpZOnc7GjsyO007ajuEO5M7ujvVO+o8DDxBPF' +
      '88bTx3PJM8rjzEPOU9Gz05PUc9Uj1tPYk9nj3B' +
      'Pio+mz6lPrY+0z7oPwk/Iz8+P3U/iz+pP8s/4D/' +
      '3QAtATUCEQKxAu0DcQPJBA0FIQYNBr0INQh1CPE' +
      'JSQnFCi0KnQt1C+EMCQ0VDZEN/Q7ZD7UQkRFpE8' +
      'UV2RYdFv0aYRtVIvUjVSN9I8EkNSSJJQkldSXhJ' +
      'r0nFSeNKBUoaSjFKRUqHSr5K5Ur1SxZLLEs9S75' +
      'MF0xHTFhMdUyMTKtMxkzhTRdNMk08TX9Nn025Tf' +
      'BOJ05eTnROf06VTutPU0+CT+ZQEFA5UG1Ql1DA' +
      'UOtRE1FHUXJRmlHFUe1SIVJMUnRSn1LH';

    function decodeOnsets(encoded) {
      const raw = atob(encoded);
      const out = [];

      for (let i = 0; i < raw.length; i += 2) {
        out.push(
          (
            raw.charCodeAt(i) * 256 +
            raw.charCodeAt(i + 1)
          ) / 100
        );
      }

      return out;
    }

    const KICK_CUES = decodeOnsets(KICK_DATA);
    const SNARE_CUES = decodeOnsets(SNARE_DATA);

    let lastCueClock = -1;
    let snarePulse = 0;
    let cueDebug = '';

    function upperBound(arr, x) {
      let a = 0;
      let b = arr.length;

      while (a < b) {
        const m = (a + b) >> 1;

        if (arr[m] <= x) a = m + 1;
        else b = m;
      }

      return a;
    }

    function applyCues(t, dt) {
      B.xPulse *= Math.exp(-dt / 0.26);
      snarePulse *= Math.exp(-dt / 0.105);

      if (
        lastCueClock < 0 ||
        t < lastCueClock - 0.04 ||
        t - lastCueClock > 0.24
      ) {
        lastCueClock = t;
        return;
      }

      const k = upperBound(
        KICK_CUES,
        lastCueClock + 0.008
      );

      if (
        k < KICK_CUES.length &&
        KICK_CUES[k] <= t + 0.015
      ) {
        B.xPulse = Math.max(B.xPulse, 0.93);
        B.thump = Math.max(B.thump, 0.8);
        cueDebug = 'KICK';
      }

      const n = upperBound(
        SNARE_CUES,
        lastCueClock + 0.008
      );

      if (
        n < SNARE_CUES.length &&
        SNARE_CUES[n] <= t + 0.015
      ) {
        snarePulse = Math.max(snarePulse, 0.8);
        cueDebug =
          cueDebug === 'KICK'
            ? 'KICK+SNARE'
            : 'SNARE';
      }

      lastCueClock = t;

      if (t >= C.song) {
        kickDebug.textContent =
          cueDebug +
          ' / X ' + B.xPulse.toFixed(2) +
          ' / SNARE ' + snarePulse.toFixed(2);
      }

      cueDebug = '';
    }

    // AJUSTE V23:
    // En móvil usar hasta 2x de resolución.
    // En escritorio se conserva el límite anterior.

    function resize() {
      W = innerWidth;
      H = innerHeight;

      DPR = Math.min(
        devicePixelRatio || 1,
        W < 680 ? 2 : 1.25
      );

      canvas.width = Math.round(W * DPR);
      canvas.height = Math.round(H * DPR);

      g.setTransform(DPR, 0, 0, DPR, 0, 0);

      buildConstellation();
      sizePhotoLayer();
    }

    addEventListener('resize', resize);

    async function audioReady() {
      if (!ac) {
        const AC =
          window.AudioContext ||
          window.webkitAudioContext;

        if (!AC) {
          throw new Error('Web Audio no disponible');
        }

        ac = new AC();
        an = ac.createAnalyser();

        an.fftSize = 4096;
        an.smoothingTimeConstant = 0.07;

        td = new Uint8Array(an.fftSize);
        fd = new Uint8Array(an.frequencyBinCount);

        source = ac.createMediaElementSource(audio);
        source.connect(an);
        an.connect(ac.destination);
      }

      if (ac.state === 'suspended') {
        await ac.resume();
      }
    }

    function sample() {
      if (!an || audio.paused) {
        for (const k of Object.keys(B)) {
          B[k] *= 0.88;
        }
        return;
      }

      an.getByteTimeDomainData(td);
      an.getByteFrequencyData(fd);

      let sum = 0;

      for (let i = 0; i < td.length; i++) {
        const v = (td[i] - 128) / 128;
        sum += v * v;
      }

      const rms = Math.sqrt(sum / td.length);
      const raw = clamp(Math.pow(rms * 9, 0.78));

      const voiceRaw = clamp(
        Math.pow(
          Math.max(0, rms - 0.004) * 4.8,
          0.78
        )
      );

      const bin = ac.sampleRate / an.fftSize;

      const band = (lo, hi) => {
        const a = Math.max(
          1,
          Math.floor(lo / bin)
        );

        const b = Math.min(
          fd.length - 1,
          Math.ceil(hi / bin)
        );

        let total = 0;

        for (let i = a; i <= b; i++) {
          total += fd[i];
        }

        return clamp(
          (
            total / Math.max(1, b - a + 1) /
            255 - 0.027
          ) * 2.7
        );
      };

      const r = {
        level: raw,
        bass: band(35, 185),
        mid: band(210, 2600),
        high: band(2900, 11000)
      };

      for (const k of Object.keys(r)) {
        B[k] +=
          (r[k] - B[k]) *
          (r[k] > B[k] ? 0.66 : 0.13);
      }

      B.voice +=
        (voiceRaw - B.voice) *
        (voiceRaw > B.voice ? 0.72 : 0.22);

      B.voiceHit = Math.max(
        B.voiceHit * 0.58,
        clamp((voiceRaw - prevVoice) * 5)
      );

      prevVoice = voiceRaw;

      slowBass +=
        (r.bass - slowBass) * 0.035;

      B.thump = Math.max(
        B.thump * 0.56,
        clamp((r.bass - slowBass) * 3.7)
      );

      average +=
        (raw - average) * 0.035;

      const suddenDrop = clamp(
        (prevLevel - raw) * 4.5
      );

      B.cut = Math.max(
        B.cut * 0.84,
        suddenDrop,
        raw < average * 0.47
          ? clamp((average - raw) * 1.8)
          : 0
      );

      B.impact = Math.max(
        B.impact * 0.66,
        clamp((raw - prevLevel) * 4.5),
        clamp((r.bass - prevBass) * 3.5)
      );

      B.shiver += (
        clamp(
          B.bass * 0.5 +
          B.thump * 1.5 +
          B.impact * 0.45
        ) - B.shiver
      ) * 0.43;

      prevRawBass = r.bass;
      prevLevel = raw;
      prevBass = r.bass;
    }

    // CONTORNO ORGÁNICO

    class Alien {
      constructor(id) {
        this.id = id;
        this.c = new Float32Array(C.N);
        this.target = new Float32Array(C.N);
        this.sp = [];
        this.last = -1e9;
        this.rng = (id * 7417 + 9217) >>> 0;
      }

      random() {
        this.rng = (
          Math.imul(this.rng, 1664525) +
          1013904223
        ) >>> 0;

        return this.rng / 4294967296;
      }

      reset() {
        this.c.fill(0);
        this.target.fill(0);
        this.sp.length = 0;
        this.last = -1e9;
      }

      update(dt, a, ms) {
        const level = a.level;

        if (
          level > 0.035 &&
          ms - this.last > 110 - level * 85
        ) {
          const count =
            1 +
            (a.onset > 0.08 ? 3 : 0) +
            (level > 0.55 ? 2 : 0);

          for (let i = 0; i < count; i++) {
            const r = () => this.random();

            this.sp.push({
              angle: r() * TAU,
              width: lerp(0.018, 0.115, r()),

              amp:
                (r() < 0.35 ? -43 : 72) *
                lerp(0.25, 1, r()) *
                (0.5 + level * 0.8),

              life: 0,
              dur: lerp(0.12, 0.55, r()),
              drift: lerp(-1.5, 1.5, r()),
              sharp: lerp(0.7, 2.6, r())
            });
          }

          if (this.sp.length > 34) {
            this.sp.splice(
              0,
              this.sp.length - 34
            );
          }

          this.last = ms;
        }

        for (
          let i = this.sp.length - 1;
          i >= 0;
          i--
        ) {
          const p = this.sp[i];

          p.life += dt;

          p.angle =
            (p.angle + p.drift * dt + TAU) %
            TAU;

          if (p.life >= p.dur) {
            this.sp.splice(i, 1);
          }
        }

        this.target.fill(0);

        for (const p of this.sp) {
          const u = p.life / p.dur;

          const env =
            (1 - Math.exp(-u * 24)) *
            Math.pow(1 - u, 1.3);

          for (let k = 0; k < C.N; k++) {
            const angle = k / C.N * TAU;

            let d = Math.abs(angle - p.angle);
            d = Math.min(d, TAU - d);

            const n = d / p.width;
            if (n > 4) continue;

            this.target[k] +=
              p.amp * env *
              (
                0.55 *
                Math.exp(-Math.pow(n, p.sharp)) +

                0.45 *
                Math.exp(-Math.pow(n * 3.5, 1.3))
              );
          }
        }

        const fineAmount =
          level *
          (4 + a.texture * 13) *
          1.3;

        for (let i = 0; i < C.N; i++) {
          const angle = i / C.N * TAU;

          const fine =
            Math.sin(angle * 43 + ms * 0.0027) *
            Math.sin(angle * 89 - ms * 0.0016) *
            Math.cos(angle * 17 + ms * 0.0011);

          this.target[i] = clamp(
            this.target[i] + fine * fineAmount,
            -43,
            72
          );

          const rate =
            this.target[i] > this.c[i]
              ? 0.60
              : 0.16;

          this.c[i] +=
            (this.target[i] - this.c[i]) *
            (
              1 -
              Math.pow(1 - rate, dt * 60)
            );
        }
      }

      radius(slot, r) {
        const i =
          Math.round(
            slot / C.per * C.N
          ) % C.N;

        return Math.max(
          1,
          r + this.c[i] * r / 76
        );
      }

      position(slot, x, y, r) {
        const a =
          slot / C.per * TAU -
          Math.PI / 2;

        const rr = this.radius(slot, r);

        return [
          x + Math.cos(a) * rr,
          y + Math.sin(a) * rr
        ];
      }
    }

    // DIEZ ORGANISMOS Y 1300 NODOS

    const parents = Array.from(
      {length: C.parents},
      (_, i) => ({
        id: i,
        alien: new Alien(i + 1),
        x: 0,
        y: 0,
        vx: 0,
        vy: 0,
        alpha: 0,
        entered: i === 0,
        mass: 0.75 + hash(i + 20) * 1.1,
        phase: hash(i + 39) * TAU
      })
    );

    const nodes = [];

    for (let i = 0; i < C.parents; i++) {
      for (let j = 0; j < C.per; j++) {
        const id = nodes.length;

        nodes.push({
          id,
          owner: i,
          slot: j,
          x: 0,
          y: 0,
          z: 0,
          vx: 0,
          vy: 0,
          vz: 0,
          px: 0,
          py: 0,
          depth: 0,
          visible: 0,
          initialized: false,
          birth:
            C.spawn + hash(id + 300) * 2.7,
          phase: hash(id + 400) * TAU,
          mass: 0.6 + hash(id + 500) * 1.5,
          noise: hash(id + 600)
        });
      }
    }

    const edges = [];

    for (let i = 0; i < C.parents; i++) {
      for (let j = 0; j < C.per; j++) {
        const a = i * C.per + j;

        edges.push([
          a,
          i * C.per + (j + 1) % C.per
        ]);

        if (j % 3 === 0) {
          edges.push([
            a,
            i * C.per + (j + 2) % C.per
          ]);
        }

        if (j % 7 === 0) {
          edges.push([
            a,
            i * C.per + (j + 3) % C.per
          ]);
        }
      }
    }

    // CONSTELACIÓN ABIERTA

    let destinations = [];
    let branches = [];

    function intersects(a, b, c, d) {
      const cross = (p, q, r) =>
        (q.x - p.x) * (r.y - p.y) -
        (q.y - p.y) * (r.x - p.x);

      const ab1 = cross(a, b, c);
      const ab2 = cross(a, b, d);
      const cd1 = cross(c, d, a);
      const cd2 = cross(c, d, b);

      return (
        ab1 * ab2 < -1e-4 &&
        cd1 * cd2 < -1e-4
      );
    }

    function buildConstellation() {
      const r = radius();
      const minDim = Math.min(W, H);

      const marginX = Math.max(
        40,
        r * 1.02
      );

      const top = Math.max(
        52,
        r * 1.12
      );

      const bottom = Math.max(
        top + 1,
        H - Math.max(95, r * 1.2)
      );

      const xmin = marginX;
      const xmax = Math.max(
        xmin + 1,
        W - marginX
      );

      const left = Math.max(
        xmin,
        Math.min(xmax, W * 0.10)
      );

      const main = {
        x: left,
        y: Math.max(
          top,
          Math.min(bottom, H * 0.47)
        )
      };

      const chosen = [main];
      const candidates = [];

      for (let yi = 0; yi < 18; yi++) {
        for (let xi = 0; xi < 27; xi++) {
          const jx = hash(xi * 31 + yi * 7);
          const jy = hash(xi * 7 + yi * 41);

          candidates.push({
            x:
              xmin +
              (xmax - xmin) *
              (xi + 0.1 + jx * 0.8) / 27,

            y:
              top +
              (bottom - top) *
              (yi + 0.1 + jy * 0.8) / 18
          });
        }
      }

      while (chosen.length < C.parents) {
        let best = null;
        let score = -Infinity;

        for (const c of candidates) {
          let nearest = Infinity;

          for (const p of chosen) {
            nearest = Math.min(
              nearest,
              Math.hypot(
                c.x - p.x,
                c.y - p.y
              )
            );
          }

          const edgeBias =
            (
              hash(
                chosen.length * 73 +
                c.x * 0.17 +
                c.y * 0.31
              ) - 0.5
            ) *
            minDim * 0.015;

          if (nearest + edgeBias > score) {
            score = nearest + edgeBias;
            best = c;
          }
        }

        chosen.push(best);
      }

      destinations = chosen;

      const visited = new Set([0]);
      const path = [0];

      while (path.length < C.parents) {
        const a = path[path.length - 1];

        let choice = -1;
        let score = Infinity;

        for (let b = 1; b < C.parents; b++) {
          if (visited.has(b)) continue;

          let crosses = false;

          for (let j = 1; j < path.length - 1; j++) {
            if (
              intersects(
                chosen[a],
                chosen[b],
                chosen[path[j - 1]],
                chosen[path[j]]
              )
            ) {
              crosses = true;
              break;
            }
          }

          if (crosses) continue;

          const d = Math.hypot(
            chosen[a].x - chosen[b].x,
            chosen[a].y - chosen[b].y
          );

          if (d < score) {
            score = d;
            choice = b;
          }
        }

        if (choice < 0) {
          for (let b = 1; b < C.parents; b++) {
            if (visited.has(b)) continue;

            const d = Math.hypot(
              chosen[a].x - chosen[b].x,
              chosen[a].y - chosen[b].y
            );

            if (d < score) {
              score = d;
              choice = b;
            }
          }
        }

        visited.add(choice);
        path.push(choice);
      }

      branches = [];

      for (let j = 1; j < path.length; j++) {
        branches.push({
          from: path[j - 1],
          to: path[j],
          start: C.links + (j - 1) * 0.43
        });
      }
    }

    function parentRadius(p) {
      return radius() *
        (
          p.id === 0
            ? 1
            : W < 650
              ? 0.54
              : 0.72
        );
    }

    function radius() {
      return Math.min(
        76,
        Math.min(W, H) * 0.20
      );
    }

    const bounds = () => ({
      cx: W * 0.5,
      cy: H * 0.47,
      s: Math.min(W, H),
      orbit: Math.min(W * 0.36, H * 0.34)
    });

    function target(p, t) {
      const {cx, cy} = bounds();

      const dest =
        destinations[p.id] || {
          x: cx,
          y: cy
        };

      if (p.id === 0) {
        const u = smooth(
          C.move,
          33.65,
          t
        );

        return [
          lerp(cx, dest.x, u),
          lerp(cy, dest.y, u)
        ];
      }

      return [dest.x, dest.y];
    }

    // SUBTÍTULOS

    const captions = [
      [0, 6.3,
        'NO SÉ SI ALGUIEN VAYA A RECORDAR LO QUE PASÓ AQUÍ.'],
      [7.04, 10,
        'QUIZÁ MAÑANA TODO SIGA IGUAL.'],
      [10.66, 12.65,
        'LAS MISMAS PERSONAS.'],
      [12.88, 14.96,
        'LAS MISMAS PREGUNTAS.'],
      [15.21, 18.26,
        'LAS MISMAS COSAS QUE NO DIJIMOS.'],
      [19.14, 23.23,
        'PERO TODAVÍA NOS QUEDAN TANTAS COSAS POR VIVIR.'],
      [23.93, 26.98,
        'TANTAS PERSONAS QUE NO CONOCEMOS.'],
      [27.48, 30.43,
        'TANTAS COSAS QUE AÚN NO PASAN.'],
      [31.38, 32.74,
        'Y A VECES...'],
      [33.05, 36.28,
        'ALGO CAMBIA SIN QUE NOS DEMOS CUENTA.'],
      [37.28, 39.92,
        'PODRÍA SER CUALQUIER DÍA.'],
      [40.75, 42.93,
        'O ESTA NOCHE.']
    ];

    // REINICIO

    function reset() {
      const {cx, cy} = bounds();

      for (const p of parents) {
        p.x = cx;
        p.y = cy;
        p.vx = p.vy = 0;
        p.alpha = p.id === 0 ? 1 : 0;
        p.entered = p.id === 0;
        p.alien.reset();
      }

      for (const n of nodes) {
        n.initialized = false;
        n.visible = 0;
        n.x = n.y = n.z = 0;
        n.vx = n.vy = n.vz = 0;
      }

      lastPhysics = 0;
      lastPaint = 0;

      prevLevel = 0;
      prevBass = 0;
      average = 0;
      slowBass = 0;
      prevVoice = 0;
      prevRawBass = 0;

      kickSpectrum = null;
      kickAverage = 0.025;
      kickNoise = 0.004;
      bassEnergyPrev = 0;
      lastKickTime = -100;

      kickDebug.textContent = 'KICK --';

      for (const k of Object.keys(B)) {
        B[k] = 0;
      }
    }

    // FÍSICA DEL ENTE

    function evolve(dt, t) {
      const {cx, cy, s} = bounds();

      const fold = smooth(
        C.fold,
        C.formed,
        t
      );

      for (const p of parents) {
        p.alpha =
          p.id === 0
            ? 1
            : smooth(
                C.appear + (p.id - 1) * 0.19,
                35.5 + (p.id - 1) * 0.16,
                t
              );

        if (p.id === 0 && t < C.move) {
          p.x = cx;
          p.y = cy;
          p.vx = p.vy = 0;
          continue;
        }

        if (p.alpha < 0.005) continue;

        if (!p.entered) {
          const [ex, ey] = target(p, t);

          p.x =
            ex + (hash(p.id + 201) - 0.5) * 12;

          p.y =
            ey + (hash(p.id + 311) - 0.5) * 12;

          p.vx = p.vy = 0;
          p.entered = true;
        }

        const [tx, ty] = target(p, t);

        const spring =
          (p.id === 0 ? 14 : 9) / p.mass;

        let ax = (tx - p.x) * spring;
        let ay = (ty - p.y) * spring;

        const jitter =
          (1 - fold) * s * 0.009;

        ax +=
          Math.sin(
            t * (0.6 + p.mass * 0.33) +
            p.phase
          ) * jitter;

        ay +=
          Math.cos(
            t * (0.52 + p.mass * 0.27) +
            p.phase
          ) * jitter;

        if (t < C.fold) {
          for (const q of parents) {
            if (
              q === p ||
              q.alpha < 0.05
            ) continue;

            const dx = p.x - q.x;
            const dy = p.y - q.y;

            const dist =
              Math.hypot(dx, dy) || 1;

            const minimum =
              (
                parentRadius(p) +
                parentRadius(q)
              ) * 1.60;

            if (dist < minimum) {
              ax +=
                dx / dist *
                (minimum - dist) * 13;

              ay +=
                dy / dist *
                (minimum - dist) * 13;
            }
          }
        }

        const drag = Math.exp(
          -3.1 * dt / p.mass
        );

        p.vx = (p.vx + ax * dt) * drag;
        p.vy = (p.vy + ay * dt) * drag;

        p.x += p.vx * dt;
        p.y += p.vy * dt;
      }

      for (const n of nodes) {
        if (t < n.birth) continue;

        const owner = parents[n.owner];

        n.visible = smooth(
          n.birth,
          n.birth + 0.55,
          t
        );

        const [sx, sy] =
          owner.alien.position(
            n.slot,
            owner.x,
            owner.y,
            parentRadius(owner)
          );

        if (!n.initialized) {
          n.x = sx;
          n.y = sy;
          n.z = 0;

          n.vx =
            (n.noise - 0.5) * s * 0.11;

          n.vy =
            (hash(n.id + 690) - 0.5) *
            s * 0.11;

          n.initialized = true;
        }

        const bloom = smooth(
          n.birth,
          n.birth + 1.7,
          t
        );

        const theta =
          n.slot / C.per * TAU;

        const stem =
          s *
          (0.015 + 0.052 * n.noise) *
          bloom;

        const flatX =
          sx +
          Math.cos(theta * 2 + n.phase) *
          stem;

        const flatY =
          sy +
          Math.sin(theta * 3 + n.phase) *
          stem;

        const u = Math.acos(
          1 -
          2 * (n.id + 0.5) /
          nodes.length
        );

        const v =
          n.id * 2.399963229728653;

        const raised = Math.pow(
          Math.max(
            0,
            Math.sin(
              u * 14 +
              v * 17 -
              t * 5.6 +
              n.phase
            )
          ),
          15
        );

        const sunken = Math.pow(
          Math.max(
            0,
            Math.cos(
              u * 8 -
              v * 12 +
              t * 3.1 +
              n.phase
            )
          ),
          11
        );

        const voice =
          Math.sin(
            u * 6 -
            v * 4 +
            t * (0.65 + n.noise * 0.4) +
            n.phase
          ) *
          B.mid * 0.35;

        const radial = clamp(
          1 +
          voice +
          raised *
          (
            0.08 +
            B.high * 1.3 +
            B.impact * 0.6
          ) -
          sunken *
          (
            0.04 +
            B.mid * 0.46
          ),
          0.32,
          2.6
        );

        const volumeRelative = clamp(
          B.level / (average + 0.08),
          0,
          1.65
        );

        const desired = clamp(
          0.55 +
          0.16 * volumeRelative +
          0.34 * B.thump +
          0.16 * B.impact +
          0.18 * B.bass -
          0.48 * B.cut,
          0.40,
          1.27
        );

        const rr =
          s * 0.205 *
          desired *
          radial;

        const gx =
          cx +
          Math.sin(u) *
          Math.cos(v) * rr;

        const gy =
          cy +
          Math.cos(u) * rr;

        const gz =
          Math.sin(u) *
          Math.sin(v) * rr;

        const tx = lerp(flatX, gx, fold);
        const ty = lerp(flatY, gy, fold);
        const tz = gz * fold;

        const spring =
          (15 + 36 * fold) /
          n.mass;

        const drag = Math.exp(
          -(2.5 + n.noise * 2.2) * dt
        );

        let ax = (tx - n.x) * spring;
        let ay = (ty - n.y) * spring;
        let az = (tz - n.z) * spring;

        const spin =
          fold * (0.45 + n.noise * 1.1);

        ax -= (n.y - cy) * spin;
        ay += (n.x - cx) * spin;

        n.vx = (n.vx + ax * dt) * drag;
        n.vy = (n.vy + ay * dt) * drag;
        n.vz = (n.vz + az * dt) * drag;

        n.x += n.vx * dt;
        n.y += n.vy * dt;
        n.z += n.vz * dt;
      }
    }

    // PROYECCIÓN TRIDIMENSIONAL Y X

    function project(t) {
      const {cx, cy, s} = bounds();

      const morph = smooth(
        C.fold,
        C.formed,
        t
      );

      const ry = t * 0.14;

      const rx =
        0.25 +
        Math.sin(t * 0.19) * 0.13;

      const cr = Math.cos(ry);
      const sr = Math.sin(ry);
      const ct = Math.cos(rx);
      const st = Math.sin(rx);

      for (const n of nodes) {
        if (!n.visible) continue;

        const x = (n.x - cx) / s;
        const y = (n.y - cy) / s;
        const z = n.z / s;

        const xx = x * cr + z * sr;
        const zz = -x * sr + z * cr;
        const yy = y * ct - zz * st;
        const depth = y * st + zz * ct;

        const pers =
          2.85 / (2.85 - depth * 0.52);

        const shiver =
          morph *
          (
            B.shiver * 0.75 +
            B.thump * 0.5
          ) *
          s * 0.022 *
          Math.sin(
            t * (45 + n.noise * 43) +
            n.phase
          );

        n.px =
          lerp(
            n.x,
            cx + xx * s * pers,
            morph
          ) +
          shiver * Math.cos(n.phase);

        n.py =
          lerp(
            n.y,
            cy + yy * s * pers,
            morph
          ) +
          shiver * Math.sin(n.phase);

        // Redobles y snare.

        const crack =
          morph *
          snarePulse *
          s * 0.012 *
          Math.sin(
            t * (82 + n.noise * 37) +
            n.phase
          );

        n.px +=
          crack *
          Math.cos(n.phase * 2.3);

        n.py +=
          crack *
          Math.sin(n.phase * 2.3);

        // Reacción temporal en X con el kick.

        const xStrength =
          smooth(C.song, C.formed, t) *
          B.xPulse;

        if (xStrength > 0.003) {
          const dx = n.px - cx;
          const dy = n.py - cy;

          const angle = Math.atan2(dy, dx);

          const diagonal = Math.pow(
            Math.abs(Math.sin(angle * 2)),
            3
          );

          const outer = smooth(
            0.08,
            0.52,
            Math.hypot(dx, dy) /
            (s * 0.205)
          );

          const factor = clamp(
            1 +
            xStrength *
            outer *
            (
              1.38 * diagonal -
              0.30 * (1 - diagonal)
            ),
            0.66,
            2.28
          );

          n.px = cx + dx * factor;
          n.py = cy + dy * factor;
        }

        // X final aprobada.
        // Se transforma el mismo organismo.

        const finalX = smooth(
          END.xBegin,
          END.xLock,
          t
        );

        if (finalX > 0.0001) {
          const dx = n.px - cx;
          const dy = n.py - cy;

          const sx = dx < 0 ? -1 : 1;
          const sy = dy < 0 ? -1 : 1;

          const dist = Math.hypot(dx, dy);

          const longitudinal =
            s *
            (
              0.012 +
              0.345 *
              Math.pow(
                clamp(dist / (s * 0.32)),
                0.86
              )
            );

          const wobble =
            s *
            (0.009 + 0.010 * n.noise) *
            Math.sin(
              n.phase * 3.1 +
              t * 0.7
            );

          const tx =
            cx +
            sx * longitudinal +
            wobble;

          const ty =
            cy +
            sy * longitudinal -
            wobble * sx * sy;

          const organic =
            finalX *
            (
              0.90 +
              0.10 *
              Math.sin(n.phase + t * 0.4)
            );

          n.px = lerp(n.px, tx, organic);
          n.py = lerp(n.py, ty, organic);
        }

        n.depth = depth;
      }
    }

    // LAS 50 FOTOGRAFÍAS ORIGINALES

    const FAN_STEMS = [
      '27f0c32d9751436faa1c7793352dc529',
      '31eca4a762cf45b9a2c8f3800073def5',
      '37d3e5e8bccf4a1da97e0adc5e5e198c',
      '37d84fae960847039bc985fa24be4ae4',
      '053a9397dae246f1b2ed3a9d2117ae25',
      '55b2fbd239e746848a6f9c35e73f515d',
      '88d2b20227da41dea884f23e553f4d08',
      '96a1b31dd6624b149e5cbf41ee1f4fa2',
      '165ebd7b16284ec49a088551411e6dd4',
      '382eeae0e53744658b7fc1cd35303ac3',
      '630df55894f945b98e0a121a9b67fdd6',
      '2196e043a13a43d8be45d42edb0eb44f',
      '2350a7b5722d438ebbd667b430bc2077',
      '3724cdbaa0e6483581e10c71a714c934',
      '3994a37ac13745008c33242e21d5782e',
      '5049b2f99d73428098505d54a86cdc26',
      '8624af4ab75b4692bd5ca9ca1e2b4261',
      '64132cb60b2647f3b24f465c73985142',
      '8165227c24a74539b2d19a1b8090ee10',
      '0426622614004cf795716879cfaf077d',
      'a0b78df203974568b89e502d5672665e',
      'a8ef86c93fe7431d867dba2a125fee95',
      'b2a0b401243a41fb963cce9bc85cf536',
      'b5ee454e801d4910a865b7470c74bc8d',
      'b7a036ec5f63457598534fb996e98532',
      'b6940bbb1ae045ec900651cfd9f0816f',
      'b2101322a2a941a399546248084bfd85',
      'bcc4885243554800a6033c719e5fd973',
      'c07b1f5ed0264d08984201b2931a78b1',
      'd7d7bcd1c895419ab979dab254926eed',
      'e5eb5b5177b54a0ab9a4cf6ea6ac4b1b',
      'e850e03885cb4484af0baaf091863111',
      'ef35288f445243a38ea00bc3f698698c',
      'f3a2bdc5d79d4f1d8e36696b2d573337',
      'f9d9d60fb37d4f5d9a2e6b77aa391dfe',
      'f60e36da26d74ae4aba48d2d623a4ca2',
      '0d7b99c0eb6642088659bf9af575f649',
      '03ed60641ddc447985f08ab0022aa0ae',
      '3c094362a9fb4e6ea8f7f369e98a6c88',
      '3cefa9616cd440f38d1484483c4b4538',
      '5b8755f34b464837a2d441d9fb2d7270',
      '6e69658fea0e4c71b3bea20b58443f9d',
      '6f289a830fc24f10b969d0d43311f490',
      '7ab0055249bb464cae1a50ec7e5e308f',
      '7b0ada26029342d7bfb220a2bee11939',
      '8e6f87b23b9541c98d850ab8978c4bdc',
      '9a2d0e9858464506bf868756b4c5b56f',
      '9baf9113a8ab4de18ced61aa4d454bd2',
      '023d8b535cf648cf97a4e2bd1808bd81',
      '024fa2dd16794b0aa2a7c277daf732fc'
    ];

    const FAN_SUFFIX =
      'tplv-jj85edgx6n-image-origin';

    const photos = FAN_STEMS.map(() => ({
      image: null,
      loaded: false,
      attempt: 0
    }));

    let photosStarted = false;
    let photosDone = 0;
    let photosFailed = 0;

    const shuffled = FAN_STEMS
      .map((_, i) => i)
      .sort(
        (a, b) =>
          hash(a + 234) -
          hash(b + 234)
      );

    const exactURLs =
      Array.isArray(window.UXSFanPhotoURLs)
        ? window.UXSFanPhotoURLs
        : [];

    function candidates(i) {
      const exact = exactURLs[i];

      if (
        typeof exact === 'string' &&
        exact.startsWith('http')
      ) {
        return [exact];
      }

      const stem = FAN_STEMS[i];
      const suffix = FAN_SUFFIX;

      const bases = [
        stem + '_' + suffix,
        stem + '-' + suffix,
        stem + '~' + suffix,
        stem + suffix
      ];

      const out = [];

      for (const name of bases) {
        for (const ext of ['jpeg', 'jpg']) {
          out.push(
            new URL(
              '/cdn/shop/files/' +
              encodeURIComponent(name) +
              '.' + ext,
              location.origin
            ).href
          );
        }
      }

      return out;
    }

    function loadOne(i) {
      return new Promise(resolve => {
        const item = photos[i];
        const urls = candidates(i);
        let attempt = 0;

        const next = () => {
          if (attempt >= urls.length) {
            photosFailed++;
            resolve();
            return;
          }

          const url = urls[attempt++];
          const image = new Image();

          image.decoding = 'async';

          image.onload = () => {
            item.image = image;
            item.loaded = true;
            photosDone++;
            resolve();
          };

          image.onerror = next;
          image.src = url;
        };

        next();
      });
    }

    function loadFanPhotos() {
      if (photosStarted) return;

      photosStarted = true;
      let cursor = 0;

      const worker = async () => {
        while (cursor < photos.length) {
          const i = cursor++;
          await loadOne(i);
        }
      };

      for (let i = 0; i < 6; i++) {
        worker();
      }
    }

    function firstAvailable(index) {
      for (let j = 0; j < 50; j++) {
        const n = shuffled[(index + j) % 50];

        if (photos[n].loaded) {
          return photos[n].image;
        }
      }

      return null;
    }

    // CAPAS INVISIBLES PARA LA MÁSCARA

    const photoLayer =
      document.createElement('canvas');

    const pg = photoLayer.getContext(
      '2d',
      {alpha: true}
    );

    const alphaLayer =
      document.createElement('canvas');

    const ag = alphaLayer.getContext(
      '2d',
      {alpha: true}
    );

    function sizePhotoLayer() {
      photoLayer.width = Math.round(W * DPR);
      photoLayer.height = Math.round(H * DPR);

      pg.setTransform(
        DPR, 0, 0, DPR, 0, 0
      );

      alphaLayer.width = photoLayer.width;
      alphaLayer.height = photoLayer.height;

      ag.setTransform(
        DPR, 0, 0, DPR, 0, 0
      );
    }

    // LAS FOTOS SOLO APARECEN EN LAS LÍNEAS

    function traceCreatureMask(t, intensity) {
      ag.clearRect(0, 0, W, H);

      ag.globalCompositeOperation =
        'source-over';

      ag.globalAlpha = 1;
      ag.strokeStyle = 'rgba(255,255,255,1)';
      ag.lineCap = 'round';
      ag.lineJoin = 'round';

      ag.lineWidth = lerp(
        2.1,
        3.8,
        intensity
      );

      const xBlend = smooth(
        END.xBegin,
        END.xLock,
        t
      );

      ag.beginPath();
      ag.globalAlpha = 1 - xBlend;

      for (const [ia, ib] of edges) {
        const a = nodes[ia];
        const b = nodes[ib];

        if (
          a.visible < 0.03 ||
          b.visible < 0.03
        ) continue;

        ag.moveTo(a.px, a.py);
        ag.lineTo(b.px, b.py);
      }

      ag.stroke();

      ag.beginPath();
      ag.globalAlpha = xBlend;

      for (const [ia, ib] of edges) {
        const a = nodes[ia];
        const b = nodes[ib];

        if (
          a.visible < 0.03 ||
          b.visible < 0.03
        ) continue;

        ag.moveTo(a.px, a.py);
        ag.lineTo(b.px, b.py);
      }

      ag.stroke();

      ag.globalAlpha = 1;
      ag.beginPath();

      for (let i = 0; i < nodes.length; i += 2) {
        const n = nodes[i];

        if (!n.visible) continue;

        ag.moveTo(
          n.px + 1.8,
          n.py
        );

        ag.arc(
          n.px,
          n.py,
          1.8,
          0,
          TAU
        );
      }

      ag.fillStyle = '#fff';
      ag.fill();

      pg.save();
      pg.globalAlpha = 1;

      pg.globalCompositeOperation =
        'destination-in';

      pg.drawImage(
        alphaLayer,
        0,
        0,
        W,
        H
      );

      pg.restore();
    }

    function drawPhoto(
      image,
      cx,
      cy,
      w,
      h,
      alpha,
      zoom = 1,
      ctx = g
    ) {
      if (!image || alpha <= 0) return;

      const iw = image.naturalWidth;
      const ih = image.naturalHeight;

      if (!iw || !ih) return;

      const scale =
        Math.max(w / iw, h / ih) / zoom;

      const srcW = w / scale;
      const srcH = h / scale;

      ctx.save();
      ctx.globalAlpha = clamp(alpha);

      ctx.drawImage(
        image,
        (iw - srcW) / 2,
        (ih - srcH) / 2,
        srcW,
        srcH,
        cx - w / 2,
        cy - h / 2,
        w,
        h
      );

      ctx.restore();
    }

    // FOTOS RÁPIDAS Y TEXTO FINAL

    function fanFinale(t) {
      if (t < END.appear) return;

      if (!photosStarted) {
        loadFanPhotos();
      }

      const cx = W * 0.5;
      const cy = H * 0.47;
      const s = Math.min(W, H);

      const fadeOut =
        1 -
        smooth(
          END.photoEnd - 1.5,
          END.xLock - 0.1,
          t
        );

      const photoAlpha = clamp(fadeOut);

      if (photoAlpha > 0.002) {
        const elapsed = Math.max(
          0,
          t - END.appear
        );

        const phase = elapsed * 11.2;
        const idx = Math.floor(phase);
        const fraction = phase - idx;

        const current = firstAvailable(
          idx % 50
        );

        const next = firstAvailable(
          (idx + 1) % 50
        );

        const cropW = Math.min(
          W * 0.83,
          H * 0.94
        );

        const cropH = Math.min(
          H * 0.94,
          W * 0.92
        );

        pg.globalCompositeOperation =
          'source-over';

        pg.clearRect(0, 0, W, H);

        drawPhoto(
          current,
          cx,
          cy,
          cropW,
          cropH,
          1,
          1,
          pg
        );

        drawPhoto(
          next,
          cx,
          cy,
          cropW,
          cropH,
          smooth(0.35, 0.94, fraction) * 0.73,
          1.04,
          pg
        );

        traceCreatureMask(
          t,
          smooth(
            END.appear,
            END.photoEnd,
            t
          )
        );

        g.save();
        g.globalAlpha = photoAlpha;

        g.drawImage(
          photoLayer,
          0,
          0,
          W,
          H
        );

        g.restore();
      }

      // TIPOGRAFÍA ORIGINAL DE UXS

      if (t >= END.title) {
        const alpha = smooth(
          END.title,
          END.title + 0.66,
          t
        );

        const isMobile = W < 680;

        g.save();

        g.fillStyle =
          'rgba(255,255,255,' + alpha + ')';

        g.textBaseline = 'middle';

        const face =
          '"Courier New", Courier, monospace';

        if (!isMobile) {
          const xHalf = s * 0.35;
          const gap = Math.max(
            9,
            s * 0.025
          );

          const available = Math.max(
            25,
            W * 0.5 - xHalf - gap - 12
          );

          let fontSize = clamp(
            s * 0.038,
            12,
            27
          );

          g.font = fontSize + 'px ' + face;

          const textWidth =
            g.measureText('EL SONIDO').width;

          if (textWidth > available) {
            fontSize = Math.max(
              9,
              fontSize * available / textWidth
            );

            g.font = fontSize + 'px ' + face;
          }

          g.textAlign = 'right';

          g.fillText(
            'UNIDOS',
            cx - xHalf - gap,
            H * 0.47
          );

          g.textAlign = 'left';

          g.fillText(
            'EL SONIDO',
            cx + xHalf + gap,
            H * 0.47
          );

        } else {
          const fontSize = clamp(
            W * 0.056,
            14,
            23
          );

          g.font = fontSize + 'px ' + face;
          g.textAlign = 'center';

          g.fillText(
            'UNIDOS',
            W * 0.5,
            H * 0.13
          );

          g.fillText(
            'EL SONIDO',
            W * 0.5,
            H * 0.80
          );
        }

        g.restore();
      }

      status.textContent =
        photosDone === 50
          ? 'UXS / SOMOS TODOS'
          : 'UXS / FOTOS ' +
            photosDone +
            '/50' +
            (
              photosFailed
                ? ' (REVISAR ENLACES)'
                : ''
            );
    }

    // RENDER PRINCIPAL

    function draw(t) {
      const {cx, cy} = bounds();
      const fold = smooth(
        C.fold,
        C.formed,
        t
      );

      g.fillStyle = '#050505';
      g.fillRect(0, 0, W, H);

      // TRANSICIÓN SUAVE DE LA V22

      if (t >= C.links && t < C.formed) {
        const retreat = smooth(
          C.fold - 0.45,
          C.formed - 0.35,
          t
        );

        const branchOpacity =
          1 -
          smooth(
            C.fold - 0.75,
            C.formed - 0.55,
            t
          );

        if (branchOpacity > 0.001) {
          for (const b of branches) {
            const growth = smooth(
              b.start,
              b.start + 0.7,
              t
            );

            if (growth <= 0) continue;

            const a = parents[b.from];
            const z = parents[b.to];

            if (z.alpha < 0.02) continue;

            const span =
              growth * (1 - retreat);

            g.beginPath();
            g.moveTo(a.x, a.y);

            g.lineTo(
              lerp(a.x, z.x, span),
              lerp(a.y, z.y, span)
            );

            g.strokeStyle =
              'rgba(255,255,255,' +
              (
                Math.min(a.alpha, z.alpha) *
                0.59 *
                branchOpacity
              ) +
              ')';

            g.lineWidth = 1;
            g.stroke();
          }
        }
      }

      // MALLA DE 1300 NODOS

      if (t >= C.spawn) {
        project(t);

        const photoDim =
          t >= END.appear && photosDone > 0
            ? (
                lerp(
                  1,
                  0.22,
                  smooth(
                    END.appear,
                    END.appear + 0.18,
                    t
                  )
                ) *
                (
                  1 -
                  smooth(
                    END.photoEnd - 1.5,
                    END.xLock,
                    t
                  )
                ) +
                0.8 *
                smooth(
                  END.photoEnd - 1.5,
                  END.xLock,
                  t
                )
              )
            : 1;

        // V23: OPACIDAD MÁS BLANCA EN MÓVIL

        const mobile = W < 680;

        const baseOpacity =
          (
            mobile
              ? clamp(
                  0.78 +
                  0.12 * B.level +
                  0.06 * B.impact,
                  0.78,
                  0.96
                )
              : clamp(
                  0.32 +
                  0.22 * B.level +
                  0.14 * B.impact,
                  0.2,
                  0.86
                )
          ) * photoDim;

        g.beginPath();

        for (const [ia, ib] of edges) {
          const a = nodes[ia];
          const b = nodes[ib];

          if (
            a.visible < 0.03 ||
            b.visible < 0.03
          ) continue;

          g.moveTo(a.px, a.py);
          g.lineTo(b.px, b.py);
        }

        g.strokeStyle =
          'rgba(255,255,255,' +
          baseOpacity +
          ')';

        g.lineWidth = mobile ? 0.76 : 0.65;
        g.stroke();

        // V23: NODOS MÁS DEFINIDOS EN MÓVIL

        g.beginPath();

        for (const n of nodes) {
          if (n.visible < 0.03) continue;

          const rr =
            (1.1 + 0.45 * B.impact) *
            (1 - 0.55 * fold);

          g.moveTo(n.px + rr, n.py);

          g.arc(
            n.px,
            n.py,
            rr,
            0,
            TAU
          );
        }

        g.strokeStyle =
          'rgba(255,255,255,' +
          (
            t >= END.appear
              ? 0.15
              : mobile
                ? 0.72
                : 0.46
          ) +
          ')';

        g.lineWidth = mobile ? 0.62 : 0.55;
        g.stroke();
      }

      // CONTORNOS QUE SE FUNDEN
      // PROGRESIVAMENTE EN LA MALLA

      for (const p of parents) {
        if (p.alpha < 0.005) continue;

        const finalPeel =
          1 -
          smooth(
            END.xBegin,
            END.xLock,
            t
          );

        if (finalPeel < 0.005) continue;

        const peel = smooth(
          C.fold - 0.2,
          C.formed,
          t
        );

        g.beginPath();

        for (let j = 0; j <= C.per; j++) {
          const k = j % C.per;

          const n =
            nodes[p.id * C.per + k];

          const [sx, sy] =
            p.alien.position(
              k,
              p.x,
              p.y,
              parentRadius(p)
            );

          const x = n.initialized
            ? lerp(sx, n.px, peel)
            : sx;

          const y = n.initialized
            ? lerp(sy, n.py, peel)
            : sy;

          if (j === 0) {
            g.moveTo(x, y);
          } else {
            g.lineTo(x, y);
          }
        }

        g.closePath();

        if (peel < 0.08) {
          g.fillStyle = '#050505';
          g.fill();
        }

        const constellationFade =
          1 -
          smooth(
            C.fold + 0.25,
            C.formed - 0.20,
            t
          );

        g.strokeStyle =
          'rgba(255,255,255,' +
          (
            p.alpha *
            finalPeel *
            constellationFade
          ) +
          ')';

        g.lineWidth = lerp(
          1.65,
          0.65,
          peel
        );

        g.stroke();
      }

      // SUBTÍTULOS

      const c = captions.find(
        a => t >= a[0] && t < a[1]
      );

      const text = c ? c[2] : '';

      if (sub.textContent !== text) {
        sub.textContent = text;
      }

      const title =
        t < C.move
          ? 'UXS / VOICE001'
          : t < C.links
            ? 'UXS / PRESENCIAS'
            : t < C.spawn
              ? 'UXS / CONEXIÓN'
              : t < C.fold
                ? 'UXS / MULTIPLICACIÓN'
                : t < C.song
                  ? 'UXS / ESTA NOCHE'
                  : 'UXS / UNIDOS X EL SONIDO';

      if (status.textContent !== title) {
        status.textContent = title;
      }

      fanFinale(t);
    }

    // BUCLE DE ANIMACIÓN

    function frame(ms) {
      if (!active) {
        raf = 0;
        return;
      }

      raf = requestAnimationFrame(frame);

      if (
        ms - lastPaint <
        1000 / C.fps
      ) return;

      const dt = lastPaint
        ? Math.min(
            (ms - lastPaint) / 1000,
            0.07
          )
        : 1 / C.fps;

      lastPaint = ms;

      const t = audio.currentTime;

      sample();
      applyCues(t, dt);

      if (t < C.formed + 1) {
        for (const p of parents) {
          if (
            p.id !== 0 &&
            p.alpha < 0.01
          ) continue;

          p.alien.update(
            dt,
            {
              level:
                t < C.song
                  ? clamp(
                      B.voice *
                      (
                        1.35 +
                        hash(p.id + 65) * 0.20
                      )
                    )
                  : clamp(
                      B.level *
                      (
                        0.75 +
                        hash(p.id + 65) * 0.45
                      ) +
                      B.mid * 0.13
                    ),

              onset:
                t < C.song
                  ? B.voiceHit
                  : B.impact,

              texture:
                t < C.song
                  ? B.voice
                  : B.mid
            },
            ms
          );
        }
      }

      // INTEGRACIÓN FÍSICA

      if (t < lastPhysics - 0.12) {
        reset();
        lastPhysics = t;
      }

      const steps = Math.min(
        6,
        Math.max(
          1,
          Math.ceil(
            (t - lastPhysics) * 30
          )
        )
      );

      const step = Math.min(
        0.05,
        Math.max(
          0,
          t - lastPhysics
        ) / steps
      );

      for (let i = 0; i < steps; i++) {
        lastPhysics += step;

        evolve(step, lastPhysics);
      }

      // RECONSTRUCCIÓN TRAS ADELANTAR

      if (t - lastPhysics > 1) {
        for (const p of parents) {
          const [x, y] = target(p, t);

          p.x = x;
          p.y = y;
          p.vx = p.vy = 0;
          p.alpha = 1;
          p.entered = true;
        }

        if (t >= C.formed) {
          const {cx, cy, s} = bounds();

          for (const n of nodes) {
            const u = Math.acos(
              1 -
              2 * (n.id + 0.5) /
              nodes.length
            );

            const v =
              n.id * 2.399963229728653;

            const rr = s * 0.205 * 0.68;

            n.x =
              cx +
              Math.sin(u) *
              Math.cos(v) *
              rr;

            n.y =
              cy + Math.cos(u) * rr;

            n.z =
              Math.sin(u) *
              Math.sin(v) * rr;

            n.vx = n.vy = n.vz = 0;
            n.initialized = true;
            n.visible = 1;
          }
        }

        lastPhysics = t;
      }

      draw(t);
    }

    // CONTROLES

    async function start() {
      if (active) return;

      if (!window.UXSOutroAudioURL) {
        console.error(
          'UXS V23: falta window.UXSOutroAudioURL'
        );
        return;
      }

      active = true;
      scene.classList.add('open');

      resize();
      loadFanPhotos();

      document.querySelectorAll('audio').forEach(a => {
        if (a !== audio) a.pause();
      });

      audio.currentTime = 0;
      reset();

      try {
        await audioReady();
        await audio.play();

        toggle.textContent = 'PAUSAR';

      } catch (err) {
        console.error('UXS Outro V23:', err);
        toggle.textContent = 'REPRODUCIR';

        status.textContent =
          'PRESIONA REPRODUCIR';
      }

      raf = requestAnimationFrame(frame);
    }

    function stop() {
      active = false;

      audio.pause();
      audio.currentTime = 0;

      scene.classList.remove('open');

      if (raf) {
        cancelAnimationFrame(raf);
      }

      raf = 0;
      sub.textContent = '';
    }

    scene.querySelector(
      '[data-action="testx"]'
    ).onclick = () => {
      if (
        active &&
        audio.currentTime >= C.song
      ) {
        B.xPulse = 1;
      }
    };

    scene.querySelector(
      '[data-action="endjump"]'
    ).onclick = async () => {
      if (!active) await start();
      if (!active) return;

      audio.currentTime = 194;
      lastCueClock = -1;

      try {
        await audioReady();
        await audio.play();
        toggle.textContent = 'PAUSAR';
      } catch (err) {
        console.error(err);
      }
    };

    scene.querySelector(
      '[data-action="photos"]'
    ).onclick = async () => {
      if (!active) await start();
      if (!active) return;

      audio.currentTime = 195.7;
      lastCueClock = -1;

      try {
        await audioReady();
        await audio.play();
        toggle.textContent = 'PAUSAR';
      } catch (err) {
        console.error(err);
      }
    };

    scene.querySelector(
      '[data-action="exit"]'
    ).onclick = stop;

    toggle.onclick = async () => {
      if (!active) return;

      if (!audio.paused) {
        audio.pause();
        toggle.textContent = 'CONTINUAR';
      } else {
        try {
          await audioReady();

          if (audio.ended) {
            audio.currentTime = 0;
          }

          await audio.play();
          toggle.textContent = 'PAUSAR';
        } catch (err) {
          console.error(err);
        }
      }
    };

    scene.querySelector(
      '[data-action="jump"]'
    ).onclick = async () => {
      if (!active) await start();
      if (!active) return;

      audio.currentTime = 29;

      try {
        await audioReady();
        await audio.play();
        toggle.textContent = 'PAUSAR';
      } catch (err) {
        console.error(err);
      }
    };

    audio.addEventListener('ended', () => {
      toggle.textContent = 'REPRODUCIR';
      status.textContent = 'UXS / FIN';
    });

    // API

    window.UXSOutro = {
      version: 'v23',
      start,
      stop,

      get active() {
        return active;
      }
    };

    // MODO PRUEBA

    if (
      new URLSearchParams(
        location.search
      ).get('uxs_outro_test') === '1'
    ) {
      const button =
        document.createElement('button');

      button.className = 'uxs-v23-test';
      button.textContent = 'PROBAR OUTRO V23';
      button.onclick = start;

      document.body.append(button);
    }

    addEventListener(
      'pagehide',
      () => {
        stop();

        if (ac && ac.state !== 'closed') {
          ac.close().catch(() => {});
        }
      },
      {once: true}
    );

    console.log('UXS Outro V23 Ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }
})();
